import Holidays from 'date-holidays';
import useScope from '../../Scope/Hooks/useScope';
import { useMemo, useState } from 'react';
import { CalendarEvent } from '../Interfaces/CalendarEvent.intefrace';
import { v4 as uuidv4 } from 'uuid';

export default function useHolidays() {
	const { countryCode } = useScope();
	const [yearsToFetchHolidays, setYearsToFetchHolidays] = useState<number[]>([
		new Date().getFullYear(),
	]);

	const hd = new Holidays(countryCode);

	const holidays: Date[] = useMemo(() => {
		const temp: Date[] = [];
		yearsToFetchHolidays.forEach(year => {
			//Loading holidays for specific year
			const holidaysData = hd.getHolidays(year);
			holidaysData
				?.filter(h => h.type === 'public')
				?.forEach(item => {
					const date = new Date(item.date);
					temp.push(date);
				});
		});
		return temp;
	}, [yearsToFetchHolidays]);

	const checkIfHaveHolidaysForYear = (year: number) => {
		setYearsToFetchHolidays(prev => {
			if (!prev.includes(year)) {
				return [...prev, year];
			}
			return prev;
		});
	};

	const getHolidaysAsFullDayEvents = (): CalendarEvent[] => {
		const temp: CalendarEvent[] = [];
		yearsToFetchHolidays.forEach(year => {
			//Loading holidays for specific year
			const holidaysData = hd.getHolidays(year);
			holidaysData
				?.filter(h => h.type === 'public')
				?.forEach(item => {
					temp.push({
						id: uuidv4(),
						start: item.date,
						end: item.date,
						backgroundColor: '#dbdbdb',
						borderColor: '#dbdbdb',
						textColor: '#000',
						allDay: true,
						title: item.name,
						editable: false,
						extendedProps: {
							isHoliday: true,
						},
					});
				});
		});
		return temp;
	};

	return {
		holidays,
		checkIfHaveHolidaysForYear,
		getHolidaysAsFullDayEvents,
	};
}
